import React, { useEffect, useState } from "react";
import PageHeader from '../../components/common/PageHeader'
import "./index.scss";
import SubDashBlock from "./SubDashBlock";
import { useDispatch, useSelector } from "react-redux";
import { getSubDashboardData } from "../../context/actions/subDashboard";
import { pagination } from '../../utils/constants';
import { tempAction } from "../../context/actions/tempAction"
import { deleteTemp } from "../../context/actions/dashboard";
const SubDashboard = () => {
	const dispatch = useDispatch();
	let user = useSelector(state => state.user);
	let payload = { limit: pagination.maxlimit, sort: 'name', order: 1, page: pagination.page, deleted: false };
	let [locations, setLocations] = useState([]);
	let [pageLoading, setPageLoading] = useState(false)



	useEffect(() => {
		// get packet uploaded monthely
		_getSubDashboardData();
	}, []);

	const _getSubDashboardData = async () => {
		setPageLoading(true)
		dispatch(getSubDashboardData(payload, (res => {
			setPageLoading(false);
			if (res?.docs) {
				setLocations(res)
			}
		})));
	}




	return (
		<>
			{/* <div className="page-wrapper noRecord"> */}

			<div className={`page-wrapper ${locations?.docs && locations?.docs.length === 0 ? `noRecord` : ``}`}>
				<PageHeader>Information</PageHeader>
				<div className="inner-wrapper">
					<div className="sub-dashboard-wrapper">
						<SubDashBlock locations={locations} pageLoading={pageLoading} />
					</div>
				</div>
			</div>
		</>
	);

}
export default SubDashboard;